import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: row nowrap;
	height: 300px;
	color: #828282;
	font-size: 13px;
`;

export const PagesContainer = styled.div`
	flex: 1;
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	scrollbar-width: thin;
	border-right: 2px solid #ccc;
	justify-content: center;
`;

export const ContentContainer = styled.div`
	flex: 3;
	overflow-y: auto;
	scrollbar-width: thin;
	background-color: #fff;
	border-radius: 0 10px 10px 0;
	padding: 15px;
	a {
		color: inherit;
		font-weight: 600;
	}
`;

export const PageButton = styled.div<{ current: boolean }>`
	padding: 12px 10px;
	width: 100%;
	height: 50px;
	user-select: none;
	cursor: pointer;
	position: relative;
	display: flex;
	align-items: center;
	line-height: 1.2;
	${({ current }) =>
		current &&
		`
        border: 2px solid #ccc;
        background-color: #fff;
        color: #0083c8;
        font-weight: 600;
        &::after {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            right: -4px;
            background-color: #fff;
            height: 100%;
            width: 4px;
            pointer-events: none;
        }
    `}
	${({ current }) =>
		!current &&
		`
		&:hover {
			background-image: linear-gradient(90deg, transparent, #ccc);
		}
	`}
`;
